import { Component, OnInit, Input, OnChanges } from '@angular/core';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { steps } from './constants';
import { ChatService } from 'app/common/chat/chat.service';
import { DeviceDetectService } from 'app/common/device-detect/device-detect.service';
import { environment } from 'environments/environment';
import { LoaderService, Loader } from 'app/common/loader/loader.service';
import { States, MerchantConfig } from 'app/application/application';
import { Router } from '@angular/router';
import { HeaderService, Header } from 'app/common/header/header.service';
import { EventDetails } from 'app/common/tracking/aws-tracker';
import { AwsTrackingService } from 'app/common/tracking/aws-tracking.service';
import { TokenService } from 'app/token/token.service';

declare var $: any;

@Component({
  selector: 'zest-offline-gc-gen-info',
  templateUrl: './offline-gc-gen-info.component.html',
  styleUrls: ['./offline-gc-gen-info.component.scss']
})
export class OfflineGcGenInfoComponent implements OnInit, OnChanges {

  @Input() states: States;
  @Input() cl: number;

  public steps = steps;
  public page = 0;
  public rupeeCommaNumberMask = {
    mask: createNumberMask({
      prefix: '₹',
      suffix: '',
      keepCharPositions: true
    }),
    guide: false
  };
  public voucherAmount = '';
  public voucherAmtvalid = false;
  public isDesktop = false;
  public maxAmt = 0;
  public minAmt = 0;
  public merchantConfig: MerchantConfig;
  public s3Url = environment.s3BucketUrl;
  public merchantName = '';
  public showcta = false;
  public merchantSettings: any;

  constructor(
    private chatService: ChatService,
    private deviceService: DeviceDetectService,
    private router: Router,
    private loaderService: LoaderService,
    private headerService: HeaderService,
    private awsTrackingService: AwsTrackingService,
    private tokenService: TokenService
  ) {
  }

  ngOnInit() {
    this.isDesktop = this.deviceService.isDesktop();
    this.merchantConfig = this.tokenService.getMerchantConfig();
    this.merchantName = this.merchantConfig.merchantName.toLowerCase();
    this.merchantSettings = this.tokenService.getMerchantSettings();
    const selectedMerchantSetting = this.merchantSettings.filter(merchant => merchant.partnerName.toLowerCase() === this.merchantName.toLowerCase())[0];
    this.maxAmt = parseInt(this.merchantSettings.filter(merchant => merchant.partnerName.toLowerCase() === this.merchantName.toLowerCase())[0].maxLimit, 10);
    this.maxAmt = this.cl < this.maxAmt ? this.cl : this.maxAmt;
    this.minAmt = parseInt(selectedMerchantSetting.minLimit, 10);
    this.showcta = (new Date()).getTime() < this.states.customer.creditLimitExpiryDate;
  }

  ngOnChanges() {
    if (this.merchantSettings) {
      this.maxAmt = parseInt(this.merchantSettings.filter(merchant => merchant.partnerName.toLowerCase() === this.merchantName.toLowerCase())[0].maxLimit, 10);
      this.maxAmt = this.cl < this.maxAmt ? this.cl : this.maxAmt;
    }
  }

  openModal() {
    const event = new EventDetails('ogc_get_voucher_modal_opened', 'event', 'clicked');
    this.awsTrackingService.sendDataToFunnel(event).subscribe();
    $('#GenVoucherModal').modal('open');
    $('body').css('overflow', 'hidden');
    this.chatService.hideChatIcon();
    setTimeout(() => {
      $('#voucher_amount').focus();
    }, 2000);
  }
  onClose() {
    setTimeout(() => {
      this.page = 0;
      this.voucherAmount = '';
      this.voucherAmtvalid = false;
    }, 300);
    $('body').css('overflow', 'unset');
    this.chatService.showChatIcon();
  }
  closeModal() {
    $('#GenVoucherModal').modal('close');
    this.onClose();
  }
  showAmtModal() {
    const event = new EventDetails('ogc_get_voucher_modal_yes', 'event', 'clicked');
    this.awsTrackingService.sendDataToFunnel(event).subscribe();
    this.page = 1;
  }
  voucherAmtChange() {
    const amt = parseInt(this.voucherAmount.replace('₹', '').replace(/,/g, ''), 10);
    if (amt >= this.minAmt && amt <= this.maxAmt) {
      this.voucherAmtvalid = true;
    } else {
      this.voucherAmtvalid = false;
    }
  }
  submit() {
    this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
    this.getVoucher();
    const event = new EventDetails('ogc_get_voucher_modal_submit', 'event', 'clicked');
    this.awsTrackingService.sendDataToFunnel(event).subscribe();
  }
  getVoucher() {
    const merchantName = this.merchantName;
    this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
    const selectedMerchantSetting = this.merchantSettings.filter(merchant => merchant.partnerName.toLowerCase() === merchantName.toLowerCase())[0];
    if (selectedMerchantSetting) {
      const data = {
        tv: merchantName,
        sz: selectedMerchantSetting.merchantId,
        ue: btoa(this.states.customer.customerId),
        va: this.maxAmt,
        ly: 'Gift Card',
        ew: parseInt(this.voucherAmount.replace('₹', '').replace(/,/g, ''), 10),
        fx: true
      };
      this.headerService.ShowHeaderSource.next(new Header(0, false, 0, false, '', false));
      this.closeModal();
      setTimeout(() => {
        this.router.navigate(['/emi/get'], { queryParams: data });
      }, 1000);
    }
  }
}
